import React from 'react';
import classNames from 'classnames';
import {Button} from '@shopify/polaris';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {LoginModalContext} from '../login-modal/LoginModal';
import {GetShopAuthQueryData} from 'sections/services-marketplace/experts/sections/with-auth/graphql/GetShopAuth.graphql';
import withAuth from 'sections/services-marketplace/experts/sections/with-auth/withAuth';
import {Routes, sendGoogleAnalytics} from '../../utilities';
import {
  GoogleAnalyticsEventActions,
  GoogleAnalyticsEventType,
} from '../../utilities/constants';

import styles from './NavigationMobile.scss';

interface OwnProps {
  onLoginModalPrompt(context: LoginModalContext): () => void;
  currentShop: GetShopAuthQueryData.CurrentShop | null;
  currentShopUser: GetShopAuthQueryData.CurrentShopUser | null;
}

type ComposedProps = WithI18nProps & OwnProps;

function SecondaryItems({
  onLoginModalPrompt,
  currentShop,
  i18n,
}: ComposedProps) {
  function createJob() {
    sendGoogleAnalytics({
      type: GoogleAnalyticsEventType.Event,
      payload: {eventAction: GoogleAnalyticsEventActions.createAJob},
    });

    if (!currentShop) return;

    window.location.assign(
      Routes.postJobLoginPath({
        shop: currentShop.permanentDomain,
      })
    );
  }

  return (
    <ul className={styles.List}>
      <li className={styles.ListItem}>
        <div className={styles.ListItemLink}>
          <a href={Routes.referralUrl('navigation-mobile')}>
            {i18n.translate('Global.Header.navigation.shopify')}
          </a>
        </div>
      </li>
      {currentShop ? (
        <li className={classNames(styles.ListItem, styles.ListItemButton)}>
          <Button primary fullWidth onClick={createJob}>
            {i18n.translate('Global.Header.navigation.buttonCta')}
          </Button>
        </li>
      ) : (
        <>
          <li className={styles.ListItem}>
            <div className={styles.ListItemLink}>
              <button
                onClick={onLoginModalPrompt(LoginModalContext.Login)}
                type="button"
              >
                {i18n.translate('Global.Header.navigation.login')}
              </button>
            </div>
          </li>
          <li className={classNames(styles.ListItem, styles.ListItemButton)}>
            <Button
              primary
              fullWidth
              onClick={onLoginModalPrompt(LoginModalContext.CreateJob)}
            >
              {i18n.translate('Global.Header.navigation.buttonCta')}
            </Button>
          </li>
        </>
      )}
    </ul>
  );
}

export default withAuth(withI18n()(SecondaryItems));
